import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const HERO_IMG =
  "https://images.unsplash.com/photo-1519078313888-5a8068170f8f?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1600";



export const Hero = () => (
  <section id="top" data-testid="hero-section" className="relative pt-32 md:pt-40 pb-24 md:pb-32">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 md:px-12 lg:grid-cols-12 lg:gap-12">
      <div className="lg:col-span-6 lg:pt-16">
        <Reveal>
          <Eyebrow>Automotive Acquisition · Toronto &amp; across Canada</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h1 data-testid="hero-headline" className="mt-8 font-display text-5xl font-light leading-[1.02] tracking-tight sm:text-6xl lg:text-7xl">
            You choose the car.
            <br />
            <em className="italic text-stone">We handle</em> everything else.
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-10 max-w-lg text-base leading-relaxed text-stone md:text-lg">
            S &amp; H takes the stress and the work out of buying a luxury car. We source it, negotiate the price,
            prepare the paperwork and arrange shipping — then hand you a finished deal package to sign, pay and receive.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-12 flex flex-wrap items-center gap-8">
            <a href="#contact" data-testid="hero-primary-cta" className="group inline-flex items-center gap-3 bg-ink px-8 py-4 text-xs uppercase tracking-[0.22em] text-ivory hover:bg-[#1a1a1a] transition-colors duration-500">
              Begin your acquisition
              <ArrowRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1" strokeWidth={1.25} />
            </a>
            <a href="#process" data-testid="hero-secondary-cta" className="link-line pb-1 text-sm text-ink">
              How it works
            </a>
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.15} className="lg:col-span-6">
        <div className="relative">
          <div className="absolute -left-6 -top-6 hidden h-full w-full border border-hairline lg:block" aria-hidden />
          <img src={HERO_IMG} alt="White luxury coupe parked against a minimalist white facade" data-testid="hero-image" className="relative aspect-[4/5] w-full object-cover" />
          <div className="absolute bottom-0 left-0 h-px w-2/3 brand-gradient" aria-hidden />
        </div>
      </Reveal>
    </div>
  </section>
);
